import { type ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { buscarIndicacoes } from '../lib/api';
import { valorConfig } from '../lib/formato';
import { useConfiguracaoPublica, useMe } from '../lib/hooks';
import { PortalShell } from '../componentes/PortalShell';
import { ListaIndicacoes } from '../componentes/ListaIndicacoes';
import { Esqueleto, EstadoVazioIndicar, FalhaRede } from '../componentes/blocos';

/**
 * Minhas indicações (UX §5.5) — **só as convertidas** (a API já filtra;
 * rejeitadas nunca aparecem, nem em agregado). Vazio — inclusive "só rejeitadas"
 * — cai no mesmo estado que convida a indicar.
 */
export function MinhasIndicacoes(): ReactNode {
  const me = useMe();
  const config = useConfiguracaoPublica();
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['me', 'indicacoes'],
    queryFn: buscarIndicacoes,
  });

  const brindeIndicado = config.data ? valorConfig(config.data, 'brinde_indicado_descricao') : null;

  return (
    <PortalShell voltarPara="/">
      <h1 className="tipo-titulo text-tinta-forte">Suas indicações</h1>

      <div className="mt-5">
        {isLoading && <Esqueleto className="h-40 rounded-2" />}
        {isError && <FalhaRede aoTentarDeNovo={() => void refetch()} />}
        {data && data.itens.length === 0 && me.data?.codigo && (
          <EstadoVazioIndicar codigo={me.data.codigo} brindeIndicado={brindeIndicado} />
        )}
        {data && data.itens.length > 0 && <ListaIndicacoes itens={data.itens} />}
      </div>
    </PortalShell>
  );
}
